var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chart-shell',{attrs:{"title":_vm.title}},[_c('div',[_c('div',{staticClass:"double-line-chart",attrs:{"id":_vm.title}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }